import api from 'api';
import { get } from 'utils/fetch';
import { Select, Space, Spin, message, Switch } from 'antd';
import { useEffect, useContext, useState } from 'react';
import { GlobalContext } from 'GlobalContext';
import { InvestorPositionsTableByAccount } from './InvestorPositionsTableByAccount';
import { USDollar, USD_TO_CNY, sumUSDFormat, sumCNYFormat } from 'utils/format';

function InvestorPositionsTableHeader() {
    return (
        <div style={{ display: 'flex' }}>
            <div
                style={{
                    width: '50px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            ></div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Account
            </div>

            <div
                style={{
                    width: '150px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Investor
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Fund
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Capital in Date
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Commitment Number
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Equity Balance
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Distribute Interest
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Principal Return
            </div>
        </div>
    );
}

function InvestorPositionsTableSummary(props) {
    const { positionsByDriInvestorsAccounts } = props;

    const usdPositions = positionsByDriInvestorsAccounts.filter(
        (position) => position.currency.toLowerCase() === 'usd'
    );

    const cnyPositions = positionsByDriInvestorsAccounts.filter(
        (position) => position.currency.toLowerCase() === 'cny'
    );
    return (
        <div
            style={{
                display: 'flex',
                borderTop: '1px solid black',
                width: 'fit-content',
                fontWeight: 'bold',
            }}
        >
            <div
                style={{
                    width: '50px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            ></div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Sum
            </div>

            <div
                style={{
                    width: '150px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            ></div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            ></div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                <div>{usdPositions.length > 0 && 'Sum USD'}</div>
                <div>{cnyPositions.length > 0 && 'Sum CNY'}</div>
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                <div>
                    {usdPositions.length > 0 &&
                        sumUSDFormat(usdPositions, 'investment_amount')}
                </div>
                <div>
                    {cnyPositions.length > 0 &&
                        sumCNYFormat(cnyPositions, 'investment_amount')}
                </div>
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                <div>
                    {usdPositions.length > 0 &&
                        sumUSDFormat(usdPositions, 'account_balance')}
                </div>
                <div>
                    {cnyPositions.length > 0 &&
                        sumCNYFormat(cnyPositions, 'account_balance')}
                </div>
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                <div>
                    {usdPositions.length > 0 &&
                        sumUSDFormat(usdPositions, 'interest_received')}
                </div>
                <div>
                    {cnyPositions.length > 0 &&
                        sumCNYFormat(cnyPositions, 'interest_received')}
                </div>
            </div>

            <div
                style={{
                    width: '100px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                <div>
                    {usdPositions.length > 0 &&
                        sumUSDFormat(usdPositions, 'principal_returned')}
                </div>
                <div>
                    {cnyPositions.length > 0 &&
                        sumCNYFormat(cnyPositions, 'principal_returned')}
                </div>
            </div>
        </div>
    );
}

function InvestorPositionsTableContent(props) {
    const {
        positionsByDriInvestorsAccounts,
        DRIAccountInvestorMap,
        uniqueAccountIds,
    } = props;

    return (
        <div>
            {uniqueAccountIds.map((accountId, idx) => (
                <InvestorPositionsTableByAccount
                    key={idx}
                    positions={positionsByDriInvestorsAccounts.filter(
                        (position) => position.account_id === accountId
                    )}
                    investors={DRIAccountInvestorMap.filter(
                        (investor) => investor.account_id === accountId
                    )}
                />
            ))}
        </div>
    );
}

export function InvestorPositionsTable() {
    const {
        setManageRecordId,
        manageRecordId,
        setManageRecordTab,
        accessToken,
        refreshSession,
    } = useContext(GlobalContext);
    const [
        positionsByDriInvestorsAccounts,
        setPositionsByDriInvestorsAccounts,
    ] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [DRIAccountInvestorMap, setDRIAccountInvestorMap] = useState([]);
    const [uniqueAccountIds, setUniqueAccountIds] = useState([]);
    const [loading, setLoading] = useState(true);
    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    useEffect(() => {
        setUniqueAccountIds(
            [
                ...new Set(
                    positionsByDriInvestorsAccounts.map(
                        (item) => item.account_id
                    )
                ),
            ].sort()
        );
    }, [positionsByDriInvestorsAccounts]);

    useEffect(() => {
        fetchPositionsByDriInvestorsAccounts(manageRecordId);
        fetchDRIAccountInvestorMap(manageRecordId);
    }, []);

    async function fetchDRIAccountInvestorMap(DRIId) {
        // not exactly map, but investor join account
        await get(
            api.manager.DRIAccountInvestorMap(DRIId),
            setDRIAccountInvestorMap,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchPositionsByDriInvestorsAccounts(DRIId) {
        await get(
            api.manager.positionsByDriInvestorsAccounts(DRIId),
            setPositionsByDriInvestorsAccounts,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }
    return (
        <>
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && positionsByDriInvestorsAccounts.length > 0 && (
                <div
                    style={{
                        overflowX: 'auto',
                    }}
                >
                    <div style={{ width: '900px' }}>
                        <InvestorPositionsTableHeader />
                        <InvestorPositionsTableContent
                            positionsByDriInvestorsAccounts={
                                positionsByDriInvestorsAccounts
                            }
                            DRIAccountInvestorMap={DRIAccountInvestorMap}
                            uniqueAccountIds={uniqueAccountIds}
                        />
                        <InvestorPositionsTableSummary
                            positionsByDriInvestorsAccounts={
                                positionsByDriInvestorsAccounts
                            }
                        />
                    </div>
                </div>
            )}
        </>
    );
}
